<template>
  <div
    id="MainProductPopup"
    class="modal fade confirm MainProductPopup"
    :class="{ 'is-open': open }"
    @click.stop="clearTable()"
  >
    <div class="modal-dialog">
      <div class="modal-content" v-if="ready">
        <div class="modal-header">
          <a @click.stop="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">選擇商品</h3>
        </div>
        <div class="modal-body px_0 py_0 text-sm">
          <!-- -------------------主要區塊start ----------------------->
          <!-- //方式一：搜尋 -->
          <section class="segment selectCustomer pb_5">
            <div class="text-red MainProductPopup__notice">
              <p>
                傳統型商品可一次選擇多張同幣別主約，投資及指數型商品一次僅能選擇一張
              </p>
              <!--因為新增收藏組合的時候也是用選擇商品的彈窗，但新增收藏組合不會有要被保人資訊，所以這裡用要被保人性別做判斷是否顯示要被保人資訊-->
              <p v-if="insurer_gender > 0 && insured_gender > 0">
                根據要/被保人資訊自動剔除無法承保的商品【目前篩選條件：要保人-{{
                  insurer_gender == "1" ? "男" : "女"
                }}/{{ insurer_age }}歲、被保人-{{
                  insured_gender == "1" ? "男" : "女"
                }}/{{ insured_age }}歲】
              </p>
            </div>
            <div class="form-group MainProductPopup__searchbar w-100 mt_10">
              <label class="mr_8"> 從主約商品名稱搜尋: </label>
              <div class="position-relative">
                <div
                  class="joinSelectedSuccess text-red"
                  v-show="methodSuccess_1"
                >
                  已加入「已選商品清單」成功。
                </div>
                <div style="margin: 0 5px" @click="clearSuccess()">
                  <!-- PC -->
                  <template>
                    <!-- :reduce="(item) => item.prod_id" -->
                    <!-- v-model="editData.prod_id" -->
                    <ProductSelect
                      :options="productList"
                      @option:selecting="selectedListHandler('add', $event)"
                      label="prod_nameAndId"
                      :clearable="true"
                      placeholder="請輸入商品代號或中文"
                    >
                      <div slot="no-options">沒有資料可供選擇 !</div>
                    </ProductSelect>
                  </template>
                </div>
              </div>
            </div>
          </section>
          <!-- //方式二：類別 -->
          <section
            class="segment selectCustomer MainProductPopup__section pb_10"
          >
            <div class="text-left MainProductPopup__section__title">
              從主約商品分類挑選:
            </div>
            <div
              class="MainProductPopup__section__buttonGroup position-relative mf-textWrap"
            >
              <div
                class="joinSelectedSuccess text-red"
                v-show="methodSuccess_2"
              >
                已加入「已選商品清單」成功。
              </div>
              <div
                class="btn btn-default mr_5 ml_0 mb_5 mt_5 px_5 py_5"
                style="line-height: 20px; height: 40px"
                v-for="classify in classifyList"
                :key="classify.pro_class"
                @click.stop="openClassifyTable(classify.pro_class)"
                :class="{
                  'is-press': nowClassifyPressing == classify.pro_class,
                }"
              >
                {{ classify.pro_class_name }}
              </div>
            </div>
            <div
              class="mfTable__table classify__table mt_10 pb_10"
              v-if="classifyShowProductList.length"
              @click.stop
            >
              <div class="mfTable__table__head">
                <div class=""></div>
                <div class="text-left">商品名稱</div>
              </div>
              <div class="mfTable__table__body">
                <div
                  class="mfTable__table__body--row"
                  v-for="item in classifyShowProductList"
                  :key="item.prod_id + 'classifyTable'"
                >
                  <div>
                    <div class="checkbox checkbox-inline">
                      <input
                        type="checkbox"
                        :id="item.prod_id + 'classifyTable'"
                        v-model="item.checked"
                        @click.stop="clearSuccess()"
                      />
                      <label :for="item.prod_id + 'classifyTable'"></label>
                    </div>
                  </div>
                  <div class="text-left mf-textWrap">
                    {{
                      `${item.prod_name}(${item.prod_id})${selectedRisk(item)}`
                    }}
                  </div>
                </div>
              </div>
            </div>
            <div class="mb_8" v-show="classifyShowProductList.length">
              <button
                type="submit"
                class="btn btn-primary btn-sm py_5"
                @click.stop="selectedListHandler('addGroupByClassify')"
              >
                加入已選商品清單
              </button>
            </div>
          </section>
          <!-- //方式三：從商品組合方案挑選: -->
          <section
            class="segment selectCustomer MainProductPopup__section pb_5"
          >
            <div class="text-left MainProductPopup__section__title">
              從商品組合方案挑選:
            </div>
            <div
              class="MainProductPopup__section__buttonGroup position-relative mf-textWrap"
            >
              <div
                class="joinSelectedSuccess text-red"
                v-show="methodSuccess_3"
              >
                已加入「已選商品清單」成功。
              </div>
              <!-- 自訂組合方案(按鈕) -->
              <div
                class="btn btn-default mr_5 ml_0 mb_5 mt_5 px_5 py_5"
                style="line-height: 20px; height: 40px"
                :class="{
                  'is-press': myComposeShowlist.length > 0,
                }"
                @click.stop="openMyComposeTable()"
              >
                我的收藏組合
              </div>
              <!-- 公司組合方案(按鈕) -->
              <div
                class="btn btn-default mr_5 ml_0 mb_5 mt_5 px_5 py_5"
                :class="{
                  'is-press': nowComGroupPressing == comGroup.setgroup_name,
                }"
                style="line-height: 20px; height: 40px"
                v-for="comGroup in comGroupList"
                :key="comGroup.setgroup_idx"
                @click.stop="openComGroupTable(comGroup)"
              >
                {{ comGroup.setgroup_name }}
              </div>
            </div>
            <!-- 自訂組合方案(表格) -->
            <div class="myCompose__wrap mt_10" @click.stop>
              <p
                v-if="isMyComposeListLoading"
                class="text-center font-weight-bold"
              >
                資料載入中...
              </p>
              <div
                class="mfTable__table myCompose__table mt_5"
                v-show="myComposeShowlist.length > 0"
                v-for="group in myComposeShowlist"
                :key="`myComposeTable_${group.setgroup_idx}`"
              >
                <div class="mfTable__table__headMultiLine">
                  <div class="mfTable__table__headMultiLine--row checkboxStyle">
                    <div>
                      <div class="checkbox checkbox-inline">
                        <input
                          type="checkbox"
                          :id="group.setgroup_idx + 'myComposeTable'"
                          v-model="group.checked"
                          @click.stop="clearSuccess()"
                        />
                        <label
                          :for="group.setgroup_idx + 'myComposeTable'"
                        ></label>
                      </div>
                    </div>
                    <div>加入收藏日期: {{ group.createROCdate }}</div>
                    <div>
                      收藏組合名稱:{{ truncate(group.setgroup_name, 30) }}
                    </div>
                  </div>
                  <div class="mfTable__table__headMultiLine--row">
                    <div class="">編號</div>
                    <div class="text-left">商品名稱</div>
                  </div>
                </div>
                <div class="mfTable__table__body">
                  <template v-for="(mc, index) in group.group_mc_list">
                    <!-- 主約 -->
                    <div
                      class="mfTable__table__body--row"
                      :key="`${group.setgroup_idx}_${mc.setmc_idx}_${mc.prod_id}${index}_MyComGroupTable`"
                    >
                      <div>建議{{ index + 1 }}</div>
                      <div class="text-left mf-textWrap">
                        {{
                          `${mc.prod_name}(${mc.prod_id})${selectedRisk(mc)}`
                        }}
                      </div>
                    </div>
                    <!-- 附約 -->
                    <div
                      class="mfTable__table__body--row scStyle"
                      v-for="(sc, index2) in mc.group_sc_list"
                      :key="`${group.setgroup_idx}_${mc.setmc_idx}_${mc.prod_id}${index}__${sc.setsc_idx}${index2}_MyComGroupTable`"
                    >
                      <div style="text-align: right">└</div>
                      <div class="text-left mf-textWrap">
                        {{ `${sc.prod_name}(${sc.prod_id})` }}
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="mb_8" v-show="myComposeShowlist.length > 0">
              <button
                type="submit"
                class="btn btn-primary btn-sm py_5"
                @click.stop="selectedListHandler('addGroupByMyCompose')"
              >
                加入已選商品清單
              </button>
            </div>
            <!-- 公司組合方案(表格) -->
            <div
              class="mfTable__table comGroup__table mt_10 pb_10"
              v-if="ComGroupShowProductObject.setgroup_idx"
              @click.stop
            >
              <div class="text-red MainProductPopup__notice mb_2 pl_2">
                {{ ComGroupShowProductObject.rmk }}
              </div>
              <div class="mfTable__table__head">
                <div class="">編號</div>
                <div class="text-left">商品名稱</div>
              </div>
              <div class="mfTable__table__body">
                <div
                  class="mfTable__table__body--row"
                  v-for="(
                    item, index
                  ) in ComGroupShowProductObject.mc_prod_list"
                  :key="item.prod_id + 'ComGroupTable'"
                >
                  <div>建議{{ index + 1 }}</div>
                  <div class="text-left mf-textWrap">
                    {{ `${item.prod_name}(${item.prod_id})` }}
                  </div>
                </div>
              </div>
            </div>
            <div class="mb_8" v-show="ComGroupShowProductObject.setgroup_idx">
              <button
                type="submit"
                class="btn btn-primary btn-sm py_5"
                @click.stop="selectedListHandler('addGroupByComGroup')"
              >
                加入已選商品清單
              </button>
            </div>
          </section>
          <!-- //已選商品清單: -->
          <section
            class="segment selectCustomer MainProductPopup__section pb_12"
          >
            <div class="text-left MainProductPopup__section__title">
              已選商品清單:
            </div>
            <div
              class="mfTable__table selected__table mt_5 pb_10"
              v-show="selectedList.length > 0"
            >
              <div class="mfTable__table__head">
                <div class="">編號</div>
                <div class="text-left">商品名稱</div>
                <div>
                  <div
                    class="btn btn-default btn-sm px_2 pt_2"
                    @click="clearAll()"
                  >
                    <img src="@/desktop/views/mf/assets/trash.svg" alt="" />
                  </div>
                </div>
              </div>
              <div class="mfTable__table__body">
                <div
                  class="mfTable__table__body--row"
                  v-for="(item, index) in selectedList"
                  :key="item.prod_id + index"
                >
                  <div>建議{{ index + 1 }}</div>
                  <div class="text-left">
                    <span class="pr_10 mf-textWrap"
                      >{{ `${item.prod_name}`
                      }}<span class="mf-textNoWrap">{{
                        `(${item.prod_id})`
                      }}</span>
                      <span class="mf-textNoWrap">{{
                        `${selectedRisk(item)}`
                      }}</span> </span
                    ><span
                      class="haveScProdCompose"
                      v-if="item.group_sc_list && item.group_sc_list.length > 0"
                      >附</span
                    >
                  </div>
                  <div>
                    <div
                      class="btn btn-default btn-sm px_2 pt_2"
                      @click.stop="deleteHandler(index)"
                    >
                      <img src="@/desktop/views/mf/assets/trash.svg" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- 確定按鈕 -->
          <section
            class="segment selectCustomer MainProductPopup__section pb_0"
          >
            <div class="action text-right px_12">
              <button
                type="submit"
                class="btn btn-default btn-sm py_5"
                @click.stop="$emit('close')"
              >
                取消
              </button>
              <button
                type="submit"
                class="btn btn-primary btn-sm py_5 ml_10"
                @click.stop="toImport()"
                :disabled="!selectedList.length"
              >
                確定
              </button>
            </div>
          </section>
          <!-- -------------------主要區塊end ----------------------->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import mf_Mixin from "@/desktop/views/mf/mixin";
import ProductSelect from "@/desktop/views/mf/plugin/vue-select/src/index.js";
export default {
  components: { ProductSelect },
  mixins: [mf_Mixin],
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    mainProductSelected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ready: false,
      orginProductList: [],
      productList: [], //searchbar撈到的清單
      selectedList: [], //已選商品清單
      //類別分類
      classifyList: [],
      nowClassifyPressing: "",
      classifyShowProductList: [],
      //公司組合方案
      comGroupList: [],
      nowComGroupPressing: "",
      ComGroupShowProductObject: {},
      //自訂組合方案
      myCompose_list: [],
      myComposeShowlist: [],
      methodSuccess_1: false,
      methodSuccess_2: false,
      methodSuccess_3: false,
      isMyComposeListLoading: false,
      insurer_age: 0, //要保人年齡
      insurer_gender: 0, //要保人性別
      insured_age: 0, //被保人年齡
      insured_gender: 0, //被保人性別
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      let queryMCListRes;
      if (this.$store.getters.McListObj) {
        queryMCListRes = this.$store.getters.McListObj;
      } else {
        queryMCListRes = await this.$mfAPI.MFB0_1000__queryMCList({
          channel_type: this.$store.getters.IsMfTesters
            ? "all"
            : this.$store.getters.UserChannelType,
          isDirectMarketingUser: this.$store.getters.IsDirectMarketingUser,
        });
        //緩存一份
        this.$store.commit("setMCListObj", queryMCListRes);
      }
      this.orginProductList = queryMCListRes.mc_prod_list;
      this.productList = this.orginProductList;
      this.orginProductList.forEach((item) => {
        item.prod_nameAndId = `${item.prod_name}(${
          item.prod_id
        })${this.selectedRisk(item)}`;
      });
      this.classifyList = queryMCListRes.mc_pro_class_list;
      //公司組合方案
      try {
        let { com_group_list } =
          await this.$mfAPI.MFB0_2000__queryComGroupList();
        //如果剛組合方案全部商品都被停售，則不顯示該方案(7/8新增機制)
        this.comGroupList =
          com_group_list.filter((group) => {
            group.mc_prod_list = group.mc_prod_list.filter((mc) => {
              return mc.channel_type != "0";
            });
            return group.mc_prod_list.length > 0;
          }) || [];
      } catch {
        this.comGroupList = [];
      }

      this.ready = true;
    },
    selectedListHandler(action, $event) {
      this.clearSuccess();
      let toAddGroup = [];
      let toAddList = [];
      let nowProdType = this.selectedList[0]
        ? this.selectedList[0].prod_type
        : null;
      let life_pol_design_type = this.selectedList[0]
        ? this.selectedList[0].life_pol_design_type
        : null;
      if (nowProdType && nowProdType == "5") {
        return this.$mfNotice("指數型商品僅能選擇一張。");
      }
      if (nowProdType && life_pol_design_type != "2") {
        return this.$mfNotice("分紅商品僅能選擇一張。");
      }
      if (nowProdType && nowProdType != "1") {
        return this.$mfNotice("投資型商品僅能選擇一張。");
      }
      let tempSelectedList = []; //暫存合併後的樣子
      switch (action) {
        case "add":
          this.methodSuccess_1 = true;
          tempSelectedList = [
            ..._.cloneDeep(this.selectedList),
            _.cloneDeep($event),
          ];
          break;

        case "addGroupByClassify":
          toAddList = _.cloneDeep(
            this.classifyShowProductList.filter((item) => {
              return item.checked;
            })
          );
          if (toAddList.length == 0) return;
          this.methodSuccess_2 = true;
          tempSelectedList = [..._.cloneDeep(this.selectedList), ...toAddList];
          break;

        case "addGroupByComGroup":
          toAddGroup = _.cloneDeep(this.ComGroupShowProductObject.mc_prod_list);
          if (toAddGroup.length == 0) return;
          this.methodSuccess_3 = true;
          tempSelectedList = [..._.cloneDeep(this.selectedList), ...toAddGroup];
          break;
        case "addGroupByMyCompose":
          let toAddMyComposeGroups = this.myComposeShowlist.filter((item) => {
            return item.checked;
          });
          if (toAddMyComposeGroups.length == 0) return;
          this.methodSuccess_3 = true;
          toAddMyComposeGroups.forEach((group) => {
            group.group_mc_list.forEach((mc) => {
              toAddList.push(mc);
            });
          });
          tempSelectedList = [
            ..._.cloneDeep(this.selectedList),
            ..._.cloneDeep(toAddList),
          ];
          break;
      }
      let valid = true;
      tempSelectedList.forEach((item, index) => {
        //合併後是否合格
        // if (item.channel_type == "0") {
        //   valid = false;
        //   return this.$mfNotice("不可選擇停售商品。");
        // }
        if (item.prod_type == "1") {
          if (item.curr != tempSelectedList[0].curr) {
            valid = false;
            this.methodSuccess_1 = false;
            this.methodSuccess_2 = false;
            this.methodSuccess_3 = false;
            return this.$mfNotice("傳統型商品限選相同幣別商品，請重新選擇。");
          }
        }
        if (
          (item.life_pol_design_type != "2" &&
            index != 0 &&
            tempSelectedList[0].prod_type == "1") ||
          (tempSelectedList[0].life_pol_design_type != "2" &&
            tempSelectedList.length > 1)
        ) {
          valid = false;
          this.methodSuccess_1 = false;
          this.methodSuccess_2 = false;
          this.methodSuccess_3 = false;
          return this.$mfNotice("分紅商品僅能選擇一張。");
        }
        if (
          (item.prod_type == tempSelectedList[0].prod_type &&
            tempSelectedList[0].prod_type != "1" &&
            index != 0) ||
          item.prod_type != tempSelectedList[0].prod_type
        ) {
          valid = false;
          this.methodSuccess_1 = false;
          this.methodSuccess_2 = false;
          this.methodSuccess_3 = false;
          if (item.prod_type == "5") {
            return this.$mfNotice("指數型商品僅能選擇一張。");
          }
          return this.$mfNotice("投資型商品僅能選擇一張。");
        }
      });
      if (valid) {
        this.selectedList = tempSelectedList;
      }
    },
    deleteHandler(index) {
      this.selectedList.splice(index, 1);
    },
    openClassifyTable(classifID) {
      this.clearSuccess();
      this.nowClassifyPressing = classifID;
      this.nowComGroupPressing = "";
      this.classifyShowProductList = [];
      this.ComGroupShowProductObject = {};
      this.myComposeShowlist = [];
      this.$nextTick(() => {
        this.classifyShowProductList = _.cloneDeep(
          this.productList.filter((item) => {
            return item.pro_class == classifID;
          })
        );
      });
    },
    clearAll() {
      this.selectedList = [];
    },
    openComGroupTable(comGroup) {
      this.clearSuccess();
      this.nowComGroupPressing = comGroup.setgroup_name;
      this.nowClassifyPressing = "";
      this.classifyShowProductList = [];
      this.ComGroupShowProductObject = {};
      this.myComposeShowlist = [];
      this.$nextTick(() => {
        this.ComGroupShowProductObject = comGroup;
      });
    },
    async openMyComposeTable() {
      this.isMyComposeListLoading = true;
      this.clearSuccess();
      this.nowComGroupPressing = "CRM建議書我的收藏組合";
      this.nowClassifyPressing = "";
      this.classifyShowProductList = [];
      this.ComGroupShowProductObject = {};
      this.myComposeShowlist = [];
      //自訂組合方案
      let queryMyGroupListRes = await this.$mfAPI.MFB0_2000__queryMyGroupList({
        agent_id: this.$store.state.userInfo.id,
      });
      this.myCompose_list = queryMyGroupListRes.group_list;
      this.$nextTick(() => {
        this.myComposeShowlist = _.cloneDeep(this.myCompose_list);
        this.isMyComposeListLoading = false;
      });
    },
    clearTable() {
      this.nowClassifyPressing = "";
      this.nowComGroupPressing = "";
      this.classifyShowProductList = [];
      this.ComGroupShowProductObject = {};
      this.myComposeShowlist = [];
    },
    clearSuccess() {
      this.methodSuccess_1 = false;
      this.methodSuccess_2 = false;
      this.methodSuccess_3 = false;
    },
    toImport() {
      //停售自動剔除&提示
      // this.$mfNotice("測試");
      this.clearSuccess();
      var errorMessage = "";
      for (let i = 0; i < this.selectedList.length; i++) {
        let mc = this.selectedList[i];
        if (mc.channel_type == "0" || mc.stop_sale == "1") {
          errorMessage += `${mc.prod_name}(${mc.prod_id})${this.selectedRisk(
            mc
          )}</br>`;
          this.selectedList.splice(i, 1);
          i--;
          continue;
        }
        if (mc.sc_prod_list) {
          for (let j = 0; j < mc.sc_prod_list.length; j++) {
            let sc = mc.sc_prod_list[j];
            if (sc.channel_type == "0" || sc.stop_sale == "1") {
              errorMessage += `${sc.prod_name}(${sc.prod_id})</br>`;
              mc.sc_prod_list.splice(j, 1);
              j--;
              continue;
            }
          }
        }
        if (mc.group_sc_list) {
          for (let k = 0; k < mc.group_sc_list.length; k++) {
            let sc_compose = mc.group_sc_list[k];
            if (sc_compose.channel_type == "0" || sc_compose.stop_sale == "1") {
              errorMessage += `${sc_compose.prod_name}(${sc_compose.prod_id})</br>`;
              mc.group_sc_list.splice(k, 1);
              k--;
              continue;
            }
          }
        }
      }
      if (errorMessage != "") {
        this.$mfNotice(
          `以下商品已停售，將自動從「已選商品清單」中剔除(剔除商品若為主約，其附加的附約將一併剔除)：`,
          () => {
            this.$emit("importProduct", this.selectedList);
            this.clearTable();
          },
          false,
          null,
          "確定",
          `<div style="font-size:20px">${errorMessage}</div>`
        );
      } else {
        this.$emit("importProduct", this.selectedList);
        this.clearTable();
      }
    },
  },
  watch: {
    //mainProductSelected為目前此建議書選擇的主約(可能編輯時會由API回傳，或是有被檢核篩選過)，因此外部發生變化需改變內部
    open(val) {
      if (!val) return;
      //被保人年齡
      this.insured_age = parseInt(
        this.$store.getters.MfEditing.insured.insured_age
      );
      //被保人性別
      this.insured_gender = parseInt(
        this.$store.getters.MfEditing.insured.insured_gender
      );
      //被保人保險年齡
      let insured_actage = this.$store.getters.MfEditing.insured
        .insured_birthday
        ? parseInt(
            moment().diff(
              moment(this.$store.getters.MfEditing.insured.insured_birthday),
              "years"
            )
          )
        : this.insured_age;
      //要保人年齡
      this.insurer_age = parseInt(
        this.$store.getters.MfEditing.insurer.insured_age
      );
      //要保人性別
      this.insurer_gender = parseInt(
        this.$store.getters.MfEditing.insurer.insured_gender
      );
      //要保人保險年齡
      let insurer_actage = this.$store.getters.MfEditing.insurer
        .insured_birthday
        ? parseInt(
            moment().diff(
              moment(this.$store.getters.MfEditing.insurer.insured_birthday),
              "years"
            )
          )
        : this.insurer_age;
      //過濾只留符合性別年齡的資料
      this.productList = this.orginProductList.filter((item) => {
        let error = this.getProdvalid(
          item,
          this.insured_age,
          item.pay_prd,
          item.pol_period,
          "主約",
          this.$store.getters.MfEditing.insured.insured_birthday,
          item.deferred_prod,
          this.insured_gender
        );
        if (error != "") {
          return false;
        }
        //投資型商品年齡檢核
        if (item.prod_type != "1") {
          let isActAge_floor = item.assured_age_kind == "2";
          let insurer_age_floor = isActAge_floor
            ? insurer_actage
            : this.insurer_age;
          //要保人年齡檢核
          let insurerAgeCheck = false;
          if (item.assured_age_ceil && item.assured_age_ceil_kind != "0") {
            let isActAge_ceil = item.assured_age_ceil_kind == "2";
            let insurer_age_ceil = isActAge_ceil
              ? insurer_actage
              : this.insurer_age; //判斷要保人年齡上限使用保險年齡或實際年齡(assured_age_ceil_kind = 1 保險年齡 、 =2 實際年齡)
            insurerAgeCheck =
              insurer_age_floor >= item.assured_age_floor &&
              insurer_age_ceil <= item.assured_age_ceil;
          } else {
            insurerAgeCheck = insurer_age_floor >= item.assured_age_floor;
          }

          if (!insurerAgeCheck) {
            return false;
          }

          isActAge_floor = item.age_floor_kind == "2"; //2=使用法定年齡
          let insured_age_floor = isActAge_floor
            ? insured_actage
            : this.insured_age;
          let isActAge_ceil = item.assured_age_ceil_kind == "2";
          let insured_age_ceil = isActAge_ceil
            ? insured_actage
            : this.insured_age;
          let age_ceil = parseInt(item.age_ceil);
          let age_floor = parseInt(item.age_floor);
          //主約被保險人年齡限制檢核
          return insured_age_ceil <= age_ceil && insured_age_floor >= age_floor;
        } else {
          return true;
        }
      });
      this.selectedList = _.cloneDeep(this.mainProductSelected);
      this.clearSuccess();
    },
  },
};
</script>

<style lang="scss" scoped>
.MainProductPopup {
  .segment {
    padding: 10px 40px 10px;
    margin-top: 0;
    margin-bottom: 10px;
    border-radius: 0;
  }
  &__notice {
    font-size: 13px;
  }
  &__searchbar {
    display: flex;
    align-items: center;
    > label {
      font-weight: 700;
    }
    > div {
      flex-grow: 1;
    }
  }
  &__section {
    &__title {
      font-weight: 700;
    }
  }
  //類別分類
  .classify__table {
    width: 85% !important;
    & > .mfTable__table__head > div {
      &:nth-of-type(1) {
        width: 10%;
        height: 40px;
      }
      &:nth-of-type(2) {
        width: 90%;
      }
    }
    & > .mfTable__table__body {
      max-height: calc(40px * 6);
      overflow-y: overlay;
    }
    & > .mfTable__table__body > .mfTable__table__body--row:nth-of-type(even) {
      background-color: #f5f5f5;
    }
    & > .mfTable__table__body > .mfTable__table__body--row > div {
      &:nth-of-type(1) {
        width: 10%;
        white-space: nowrap;
        height: 40px;
      }
      &:nth-of-type(2) {
        width: 90%;
      }
    }
  }
  //自訂收藏組合
  .myCompose__wrap {
    max-height: 500px;
    overflow: auto;
  }
  .myCompose__table {
    width: 100% !important;
    & > .mfTable__table__headMultiLine > .mfTable__table__headMultiLine--row {
      & > div {
        &:nth-of-type(1) {
          width: 10%;
          height: 40px;
          line-height: 40px;
        }
        &:nth-of-type(2) {
          width: 95%;
        }
      }
      &.checkboxStyle > div {
        &:nth-of-type(1) {
          width: 10%;
          height: 40px;
          line-height: 40px;
        }
        &:nth-of-type(2) {
          width: 40%;
          text-align: left !important;
          white-space: nowrap;
        }
        &:nth-of-type(3) {
          width: 60%;
          text-align: left !important;
          white-space: nowrap;
        }
      }
    }

    & > .mfTable__table__body {
      max-height: auto;
      overflow-y: overlay;
    }
    & > .mfTable__table__body > .mfTable__table__body--row {
      border-radius: 4px;
    }
    & > .mfTable__table__body > .mfTable__table__body--row.scStyle {
      background-color: #f5f5f5;
    }
    & > .mfTable__table__body > .mfTable__table__body--row > div {
      &:nth-of-type(1) {
        width: 10%;
        height: 40px;
        line-height: 40px;
        padding: 0 12px !important;
        white-space: nowrap;
      }
      &:nth-of-type(2) {
        width: 90%;
        padding: 0 12px !important;
      }
    }
  }
  //公司組合方案
  .comGroup__table {
    width: 100% !important;
    & > .mfTable__table__head > div {
      &:nth-of-type(1) {
        width: 15%;
        height: 40px;
        line-height: 40px;
      }
      &:nth-of-type(2) {
        width: 85%;
      }
      &:nth-of-type(3) {
        // width: 15%;
      }
    }
    & > .mfTable__table__body {
      max-height: calc(40px * 6);
      overflow-y: overlay;
    }
    & > .mfTable__table__body > .mfTable__table__body--row {
      border-radius: 4px;
      border: solid 1px #c2c4c7;
    }
    & > .mfTable__table__body > .mfTable__table__body--row:nth-of-type(even) {
      background-color: #f5f5f5;
    }
    & > .mfTable__table__body > .mfTable__table__body--row > div {
      &:nth-of-type(1) {
        width: 15%;
        height: 40px;
        line-height: 40px;
      }
      &:nth-of-type(2) {
        width: 85%;
      }
      &:nth-of-type(3) {
        // width: 15%;
      }
    }
  }
  //已選商品清單
  .selected__table {
    width: 85% !important;
    & > .mfTable__table__head > div {
      &:nth-of-type(1) {
        width: 15%;
      }
      &:nth-of-type(2) {
        width: 70%;
        padding: 0 8px !important;
      }
      &:nth-of-type(3) {
        width: 15%;
      }
    }
    & > .mfTable__table__body {
      max-height: calc(39px * 8);
      overflow-y: overlay;
    }
    & > .mfTable__table__body > .mfTable__table__body--row:nth-of-type(even) {
      background-color: #f5f5f5;
    }
    & > .mfTable__table__body > .mfTable__table__body--row > div {
      &:nth-of-type(1) {
        width: 15%;
        white-space: nowrap;
      }
      &:nth-of-type(2) {
        width: 70%;
        padding: 8px !important;
        height: 50px;
        display: flex;
        align-items: center;
        .haveScProdCompose {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          width: 25px;
          height: 25px;
          color: #fff;
          background-color: #027a39;
          border-radius: 4px;
        }
      }
      &:nth-of-type(3) {
        width: 15%;
        padding-right: 20px;
      }
    }
  }
}
.joinSelectedSuccess {
  position: absolute;
  left: 4px;
  bottom: -16px;
  font-size: 12px;
}
</style>
